import { useAssistantContextStore } from "./assistantContext";
import { usePlanProjectionStore } from "./planProjection";
import { useReflectProjectionStore } from "./reflectProjection";
import { useReviewProjectionStore } from "./reviewProjection";
import { useTodayProjectionStore } from "./todayProjection";

export type ProjectionStoreKey =
  | "today"
  | "plan"
  | "review"
  | "reflect"
  | "assistant";

const stores = {
  today: useTodayProjectionStore,
  plan: usePlanProjectionStore,
  review: useReviewProjectionStore,
  reflect: useReflectProjectionStore,
  assistant: useAssistantContextStore,
} satisfies Record<ProjectionStoreKey, { getState: () => { invalidate: () => void } }>;

export function invalidateProjectionStores(keys?: ProjectionStoreKey[]) {
  const targets = keys ?? (Object.keys(stores) as ProjectionStoreKey[]);
  for (const key of targets) {
    stores[key].getState().invalidate();
  }
}
